export default function NoResults() {
  return (
    <div className="w-full h-full min-h-[300px] flex items-center justify-center">
      <h1 className="text-2xl font-semibold">No Results found</h1>
    </div>
  )
}